import React, {useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router';
import {toast} from 'react-toastify';
import classNames from 'classnames';
import './index.scss';

import RoleManager from '../../../services/roleManage';

import {
  CONTROL_TYPE,
  MODEL_CONTROL_TYPE,
  POPUP_ITEM_TYPE,
  ROLES_MANAGER_TYPE,
  USER_FILTER_ROLES,
  WAITER_TYPES,
} from '../../../utils/enums';
import {createAction} from '../../../utils/sagaHelper';

import Waiter from '../Waiter/Waiter';
import AddButton from '../AddButton';
import IconButton from '../IconButton';
import FilterTriggerControl from '../FilterTriggerControl';
import CouriersShiftWithControlCenterPopup from '../CouriersShiftWithControlCenterPopup/index.js';
import {ImportFileControl} from '../../../services/controlModels/importFileControl.js';
import DateRangePickerPopup from '../DateRangePickerPopup/index.js';
import {ActionButtonControl} from '../../../services/controlModels/actionButton.js';
import {DropdownControl} from '../../../services/controlModels/dropdownModel/DropdownModel.js';
import {ListItemsControl} from "../../../services/controlModels/listItemsModel/listItemsModel.js";
import {RegionTemplatesControl} from '../../../services/controlModels/regionTemplatesControl.js';
import {getQuantityFilters} from "../../../services/filter.js";
import ExportFileControl from '../ExportFileControl/ExportFileControl.jsx';

const SectionItemsTitleControls = ({
  sectionModel,
  items,
  item,
  onBack,
  onSetDragMode,
  onLayout,
  onSaveDragChanges,
  onUpdateSectionModelData,
  onFilterOrdersClose,
  saveDragModeLoader,
  itemAction,
  systemLanguage,
  models
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [courierShiftPopupIsOpen, setCourierShiftPopupIsOpen] = useState(false);
  const [datePickerIssOpen, setDatePickerIssOpen] = useState(false);
  const [defaultValueDate, setDefaultValueDate] = useState({startDate: null, endDate: null});
  const [disableDateBefore,setDisableDateBefore] = useState({startDate: null, endDate: null});
  const dispatch = useDispatch();

  const handleOnIconControlAction = action => {
    return new Promise((resolve, reject) => {
      if (action) {
        itemAction(action, sectionModel).then(
          () => resolve(),
          error => {
            toast.error(error || 'Error');
            reject();
          }
        );
      } else {
        reject();
      }
    });
  };

  const handleOnAddButton = control => {
    if (control.openCourierShiftPopup) {
      setCourierShiftPopupIsOpen(true);
      return;
    }

    if (control.openDateRange) {
      const date = items[items.length - 1];
      if(date){
        setDefaultValueDate({startDate: date.startDate,endDate: date.endDate});
        setDisableDateBefore({startDate: date.startDate,endDate: date.endDate});
      }
      setDatePickerIssOpen(true);
      return;
    }

    if (control.isLayout && onLayout) {
      onLayout(control.url.split('?')[0], null);
    } else {
      history.push(control.url);
    }
  };

  const handleOnSaveRangePicker = (data) => {
    if (!data || !sectionModel.rangePickerAction) return;

    dispatch(createAction(sectionModel.rangePickerAction, data));
  }


  const handleOnFilterClick = () => {
    onFilterOrdersClose && onFilterOrdersClose();
  };

  const checkDisabled = () => {
    return item?.values?.length ?? items?.length;
  }

  return (
    <div className={classNames('sectionItemsTitleControls')}>
      {(sectionModel.triggerControls || []).map(control => (
        <div key={`control-${control.type}`} className={classNames('controlItem')} style={control.customStyles ? control.customStyles : {}}>
          {control.type === MODEL_CONTROL_TYPE.back && <IconButton isIcon={true} iconName='next' onClick={onBack} />}
        </div>
      ))}
      {(sectionModel.controls || [])
        .filter(
          control =>
            (!control.isShow || control.isShow(items)) &&
            control.type !== MODEL_CONTROL_TYPE.back &&
            (!sectionModel.isDraggable || control.type === MODEL_CONTROL_TYPE.sortMode)
        )
        .map((control, i) => (
          <div key={`control-${control.type}-${i}`} className={classNames('controlItem', control.customClassName ? control.customClassName() : "")} style={control.customStyles ? control.customStyles : {}}>
            {control.type === MODEL_CONTROL_TYPE.add &&
              RoleManager.instance.isAuthorized(
                ROLES_MANAGER_TYPE[CONTROL_TYPE.linkIconComponent],
                sectionModel.typeModel + 'AddButton'
              ) && <AddButton text={control.text} onClick={() => handleOnAddButton(control)} />}
            {control.type === MODEL_CONTROL_TYPE.importFile && control.isShow(items) && (
              <ImportFileControl disabled={!checkDisabled()} control={control} />
            )}
            {control.type === MODEL_CONTROL_TYPE.exportFile && control.isShow(items) && (
              <ExportFileControl control={control} model={sectionModel} />
            )}
            {control.type === MODEL_CONTROL_TYPE.actionButton && control.isShow(items) && (
                <ActionButtonControl control={control} model={sectionModel} models={models} itemAction={itemAction} />
            )}
            {control.type === MODEL_CONTROL_TYPE.dropdown && control.isShow(items) && (
                <DropdownControl control={control} model={sectionModel} models={models} itemAction={itemAction} />
            )}
            {control.type === MODEL_CONTROL_TYPE.listItems && control.isShow(items) && (
                <ListItemsControl control={control} model={sectionModel} models={models} itemAction={itemAction} />
            )}
            {control.type === MODEL_CONTROL_TYPE.regionTemplates && control.isShow(items) && (
                <RegionTemplatesControl control={control} />
            )}
            {control.type === MODEL_CONTROL_TYPE.iconControl &&
              control.isShow(items) &&
              (control.icon ? (
                <IconButton
                  disabled={!checkDisabled()}
                  hideTooltip={control.hideTooltip}
                  iconName={control.icon}
                  text={control.text}
                  useClass={classNames('actionButton', {disabled: !checkDisabled()})}
                  tooltipText={control.tooltipText}
                  onClick={() => handleOnIconControlAction(control.action)}
                />
              ) : (
                <Waiter
                  disabled={!checkDisabled()}
                  type={WAITER_TYPES.span}
                  tooltipText={control.tooltipText}
                  useClass={classNames('actionButton', {disabled: !checkDisabled()})}
                  stopPropagation={true}
                  spanText={control.text}
                  handleOnClick={() => handleOnIconControlAction(control.action)}
                />
              ))}
            {control.type === MODEL_CONTROL_TYPE.sortMode && (
              <div className={classNames('sortTrigger')}>
                {!sectionModel.isDraggable && (
                  <button className={classNames('btn', 'confirm')} onClick={onSetDragMode}>
                    <span className={'btnText'}>{t('settings.SORT_MODE_BUTTON')}</span>
                    <IconButton isIcon iconName={'reorder'} />
                  </button>
                )}
                {sectionModel.isDraggable && (
                  <button
                    className={classNames('btn', 'denied')}
                    onClick={() => onUpdateSectionModelData({ isDraggable: !sectionModel.isDraggable })}
                    disabled={saveDragModeLoader}
                  >
                    {t('settings.SORT_MODE_CANCEL_BUTTON')}
                  </button>
                )}
                {sectionModel.isDraggable && (
                  <button
                    className={classNames('btn', 'confirm')}
                    disabled={saveDragModeLoader}
                    onClick={onSaveDragChanges}
                  >
                    {t('settings.SORT_MODE_SAVE_BUTTON')}
                  </button>
                )}
              </div>
            )}
            {control.type === MODEL_CONTROL_TYPE.filter && <FilterTriggerControl filterCounter={getQuantityFilters(sectionModel?.filterOptions?.options || {})} onClick={handleOnFilterClick} />}
          </div>
        ))}
      {courierShiftPopupIsOpen && (
        <CouriersShiftWithControlCenterPopup
          itemType={POPUP_ITEM_TYPE.courierShiftItem}
          roles={[USER_FILTER_ROLES.courier]}
          isOpen={courierShiftPopupIsOpen}
          onClose={() => setCourierShiftPopupIsOpen(false)}
        />
      )}

      {datePickerIssOpen && (
          <DateRangePickerPopup
              tab={1}
              isOpen={datePickerIssOpen}
              systemLanguage={systemLanguage}
              disableDateBefore={disableDateBefore}
              defaultStartDate={defaultValueDate.endDate}
              onClose={date => {
                setDatePickerIssOpen(false)
                handleOnSaveRangePicker(date);
              }}
          />
      )
      }
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    itemAction: (action, data) => dispatch(createAction(action, data)),
  };
};

export default connect(null, mapDispatchToProps)(SectionItemsTitleControls);
